import styled from 'styled-components';

export const Loading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  border-radius: 10px;
`;


export const SucessMessage = styled.span`
  color: ${props => props.theme.colors.text};
  font-weight:bold;
  font-size:large
`;



